import { SortPage, SortDirection } from './../../../models/pagination/sort-page';
import { MasterDataService, Spec } from '../../../services/api/masterdata/masterdata.service';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SearchObject } from 'src/app/models/pagination/search-object';
import { UpdateMasterDataComponent } from './update-master-data/update-master-data.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { ConfirmationDialogComponent } from 'src/app/core/components/confirmation-dialog.component';

@Component({
  selector: 'app-master-data',
  templateUrl: './master-data.component.html',
  styleUrls: ['./master-data.component.scss']
})
export class MasterDataComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  elements: MatTableDataSource<Spec> = new MatTableDataSource();
  resultsLength: number = 0;
  private readonly _destroy$: Subject<void> = new Subject<void>();

  searchObject: SearchObject = new SearchObject(10, 0);
  sortPage: SortPage = new SortPage("createdAt", SortDirection.DESC);

  tooltip = {
    refresh: '',
    edit: '',
    delete: ''
  }

  displayedColumns: string[] = [
    'name',
    'description',
    'actions'
  ];

  form: FormGroup;

  constructor(
    private translate: TranslateService,
    private masterDataService: MasterDataService,
    private router: Router,
    private dialog: MatDialog,
    private notificationsService: NotificationsService
  ) { }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(data => {
      this.sortPage = new SortPage(data['active'], SortDirection[data['direction'].toUpperCase()] as SortDirection);
      this.searchObject.sort = this.sortPage;
    });
  }

  ngOnInit() {
    this.initTooltips();
    this.getFormItemSpec();
  }

  private initTooltips() {
    this.translate.get('DUMMY.key').subscribe((translated: string) => {
      this.tooltip.refresh = this.translate.instant('TOOLTIPS.refreshResults');
      this.tooltip.edit = this.translate.instant('TOOLTIPS.updateMasterData');
      this.tooltip.delete = this.translate.instant('TOOLTIPS.deleteMasterData');
    });
  }

  getFormItemSpec() {
    this.searchObject.sort = this.sortPage;
    this.masterDataService.getFormItemSpec().pipe(takeUntil(this._destroy$)).subscribe(res => {
      this.elements.data = res;
      console.log(res);
    });
  }

  delete(spec: Spec) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { text: `Se eliminarán todos los datos maestros asociados a este tipo.` }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.confirmDelete(spec);
      }
    });
  }

  confirmDelete(spec: Spec) {
    this.masterDataService.deleteSpec(spec.hjid).subscribe(
      () => {
        this.notificationsService.showNotification(`El dato maestro ${spec.type} se eliminó correctamente`, NotificationLevel.SUCCESS);
        this.search();
      },
      (error) => {
        this.notificationsService.showNotification(
          `Ha habido un problema al eliminar el dato maestro ${spec.type}`,
          NotificationLevel.ERROR);
      }
    );
  }

  update(spec: Spec) {
    const matDialogRef = this.dialog.open(UpdateMasterDataComponent, {
      data: { spec },
      disableClose: true,
      hasBackdrop: true,
      width: '75%',
      maxHeight: '70%',
      restoreFocus: false,
      autoFocus: false
    });
    matDialogRef.afterClosed().subscribe(() => this.getFormItemSpec());
  }

  goToNewSpec() {
    this.router.navigate([`/provision/management/master-data/add-spec`]);
  }

  search() {
    this.getFormItemSpec();
  }
}
